import remote from '../remote'

const state = {
  customers: []
}

const getters = {
  CUSTOMERS: state => {
    return state.customers
  },
  CUSTOMER_BY_ID: (state, getters) => (id) => {
    return state.customers.find(customer => customer.id === id)
  }
}

const mutations = {
  SET_CUSTOMERS: (state, payload) => {
    state.customers = payload
  },
  SET_CUSTOMER: (state, customer) => {
    state.customers = [
      ...state.customers.map(item => item.id !== customer.id ? item : { ...item, ...customer })
    ]
  }
}

const actions = {
  GET_CUSTOMERS: async (context, payload) => {
    let { data } = await remote().get('/api/customers')
    context.commit('SET_CUSTOMERS', data.customers)
  },
  SET_CUSTOMER: async (context, payload) => {
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/customer.js